/** Sample data used only while spotlight tours run — keeps highlights meaningful. */

export const TOUR_DEMO_MOTION_ID = 'pp-tour-demo-motion';

export function buildTourDemoMotion() {
  return {
    id: TOUR_DEMO_MOTION_ID,
    type: 'MAIN',
    text: 'That the organization adopt the proposed annual budget for the coming fiscal year.',
    member: 'Alex Rivera',
    seconded: true,
    secondedBy: 'Jordan Lee',
    status: 'open_debate',
    timestamp: new Date().toLocaleTimeString(),
    parentMotionId: null,
  };
}

export function buildTourDemoSpeakers() {
  return {
    currentSpeaker: 'Sam Patel',
    speakerTime: 95,
    speakerQueue: ['Morgan Chen', 'Riley Brooks'],
  };
}

/** Sample Activity / minutes lines for meeting & observer tours */
export function buildTourDemoMinutes(motion = buildTourDemoMotion()) {
  const now = Date.now();
  return [
    {
      id: 'pp-tour-min-1',
      text: 'Meeting called to order',
      timestamp: new Date(now - 120000).toLocaleTimeString(),
      chronologicalOrder: now - 120000,
      type: 'call_to_order',
      status: 'completed',
    },
    {
      id: 'pp-tour-min-2',
      text: 'Committee Reports completed',
      timestamp: new Date(now - 60000).toLocaleTimeString(),
      chronologicalOrder: now - 60000,
      type: 'agenda_completion',
      status: 'completed',
    },
    {
      id: 'pp-tour-min-3',
      text: motion.text,
      timestamp: motion.timestamp || new Date(now - 30000).toLocaleTimeString(),
      chronologicalOrder: now - 30000,
      type: 'motion',
      status: 'pending',
      motionData: { ...motion },
      parentMotionId: null,
    },
    {
      id: 'pp-tour-min-4',
      text: 'Debate opened on the pending main motion.',
      timestamp: new Date(now - 10000).toLocaleTimeString(),
      chronologicalOrder: now - 10000,
      type: 'chair_note',
      status: 'completed',
      activityOnly: true,
    },
  ];
}

export const TOUR_DEMO_JOIN_CODE = 'TOUR42';

export const TOUR_DEMO_COMMITTEE_ID = 'pp-tour-demo-committee';

export function buildTourDemoCommittees() {
  return [
    {
      id: TOUR_DEMO_COMMITTEE_ID,
      name: 'Finance Committee',
      type: 'standing',
      chair: 'Taylor Nguyen',
      chairUserId: null,
      memberships: [
        { userId: 'tour-1', role: 'chair', displayName: 'Taylor Nguyen' },
        { userId: 'tour-2', role: 'member', displayName: 'Chris Alvarez' },
        { userId: 'tour-3', role: 'member', displayName: 'Jamie Ortiz' },
      ],
      members: ['Taylor Nguyen', 'Chris Alvarez', 'Jamie Ortiz'],
      description: 'Oversees budget, audits, and financial recommendations to the assembly.',
      referredItems: [
        {
          id: 'pp-tour-ref-1',
          title: 'Review proposed annual budget',
          status: 'pending',
          dateReferred: new Date().toLocaleDateString(),
          instructions: 'Report with recommendation',
        },
        {
          id: 'pp-tour-ref-2',
          title: 'Recommend dues adjustment',
          status: 'completed',
          disposition: 'favorable',
          dateReferred: new Date().toLocaleDateString(),
        },
      ],
      created: new Date().toLocaleDateString(),
    },
    {
      id: 'pp-tour-demo-committee-2',
      name: 'Governance Committee',
      type: 'standing',
      chair: 'Casey Morgan',
      chairUserId: null,
      memberships: [
        { userId: 'tour-4', role: 'chair', displayName: 'Casey Morgan' },
        { userId: 'tour-5', role: 'member', displayName: 'Drew Kim' },
      ],
      members: ['Casey Morgan', 'Drew Kim'],
      description: 'Reviews bylaws and organizational structure.',
      referredItems: [],
      created: new Date().toLocaleDateString(),
    },
  ];
}

/** Fake org roster/login-user pool for the committee create form's member picker —
 * never the signed-in account's own identity or real org members. */
export function buildTourDemoOrgUsers() {
  return [
    { userId: 'tour-org-user-1', displayName: 'Taylor Nguyen', email: 'taylor.nguyen@example.org', hasLogin: true, rosterId: 'tour-org-roster-1' },
    { userId: 'tour-org-user-2', displayName: 'Chris Alvarez', email: 'chris.alvarez@example.org', hasLogin: true, rosterId: 'tour-org-roster-2' },
    { userId: 'tour-org-user-3', displayName: 'Jamie Ortiz', email: 'jamie.ortiz@example.org', hasLogin: true, rosterId: 'tour-org-roster-3' },
    { userId: 'tour-org-user-4', displayName: 'Casey Morgan', email: 'casey.morgan@example.org', hasLogin: true, rosterId: 'tour-org-roster-4' },
    { userId: 'tour-org-user-5', displayName: 'Drew Kim', email: 'drew.kim@example.org', hasLogin: true, rosterId: 'tour-org-roster-5' },
    { userId: 'tour-org-user-6', displayName: 'Morgan Reyes', email: 'morgan.reyes@example.org', hasLogin: true, rosterId: 'tour-org-roster-6' },
  ];
}

export function buildTourDemoElectionSetup() {
  return {
    office: 'President',
    speechTimeLimit: 3,
    seatsToFill: 1,
    secretBallot: true,
    allowWriteIns: true,
    showVoteBreakdown: true,
  };
}

export function buildTourDemoNominees() {
  return [
    {
      id: 'pp-tour-nominee-1',
      name: 'Alex Rivera',
      nominatedBy: 'Jordan Lee',
      status: 'accepted',
      hasSpoken: false,
      votes: 0,
    },
    {
      id: 'pp-tour-nominee-2',
      name: 'Sam Patel',
      nominatedBy: 'Morgan Chen',
      status: 'accepted',
      hasSpoken: false,
      votes: 0,
    },
    {
      id: 'pp-tour-nominee-3',
      name: 'Riley Brooks',
      nominatedBy: 'Casey Morgan',
      status: 'pending',
      hasSpoken: false,
      votes: 0,
    },
  ];
}

/** Nominees for speech stage — all accepted; first has spoken. */
export function buildTourDemoSpeechNominees() {
  return [
    {
      id: 'pp-tour-nominee-1',
      name: 'Alex Rivera',
      nominatedBy: 'Jordan Lee',
      status: 'accepted',
      hasSpoken: true,
      votes: 0,
    },
    {
      id: 'pp-tour-nominee-2',
      name: 'Sam Patel',
      nominatedBy: 'Morgan Chen',
      status: 'accepted',
      hasSpoken: false,
      votes: 0,
    },
  ];
}

export function buildTourDemoBallotVotes() {
  return {
    'pp-tour-nominee-1': 12,
    'pp-tour-nominee-2': 8,
  };
}

export function buildTourDemoCurrentElection(office = 'President') {
  return {
    id: 'pp-tour-demo-election',
    office,
    speechTimeLimit: 3,
    secretBallot: true,
    allowWriteIns: true,
    showVoteBreakdown: true,
    seatsToFill: 1,
    status: 'nominations_open',
    timestamp: new Date().toLocaleTimeString(),
    electionNominees: [],
  };
}
